import { RootState } from 'editor/src/store/index';

const getPreviousStates = (state: RootState) => state.editorModules.undoRedo.previous;

export default getPreviousStates;
